import { PortfolioItem } from "../types"

export const PortfolioData: PortfolioItem[] =
    [
        /*
        {
            cover: "assets/images/gallery/1/thumbnail.jpg",
            elements: ["assets/images/gallery/1/photo_001.jpg", "assets/images/gallery/1/photo_002.jpg", "assets/images/gallery/1/photo_003.jpg", "assets/images/gallery/1/photo_004.jpg", "assets/images/gallery/1/photo_005.jpg", "assets/images/gallery/1/photo_006.jpg"]
        },
        */
        {
            cover: "assets/images/gallery/10/thumbnail.jpg",
            elements: ["assets/images/gallery/10/photo_001.jpg", "assets/images/gallery/10/photo_002.jpg", "assets/images/gallery/10/photo_003.jpg", "assets/images/gallery/10/photo_004.jpg"]
        },
        {
            cover: "assets/images/gallery/11/thumbnail.jpg",
            elements: ["assets/images/gallery/11/photo_001.jpg", "assets/images/gallery/11/photo_002.jpg", "assets/images/gallery/11/photo_003.jpg"]
        },
        {
            cover: "assets/images/gallery/12/thumbnail.jpg",
            elements: ["assets/images/gallery/12/photo_001.jpg", "assets/images/gallery/12/photo_002.jpg", "assets/images/gallery/12/photo_003.jpg", "assets/images/gallery/12/photo_004.jpg", "assets/images/gallery/12/photo_005.jpg", "assets/images/gallery/12/photo_006.jpg", "assets/images/gallery/12/photo_007.jpg", "assets/images/gallery/12/photo_008.jpg", "assets/images/gallery/12/photo_009.jpg"]
        },
        {
            cover: "assets/images/gallery/13/thumbnail.jpg",
            elements: ["assets/images/gallery/13/photo_001.jpg", "assets/images/gallery/13/photo_002.jpg"]
        },
        {
            cover: "assets/images/gallery/14/thumbnail.jpg",
            elements: ["assets/images/gallery/14/photo_001.jpg", "assets/images/gallery/14/photo_002.jpg", "assets/images/gallery/14/photo_003.jpg", "assets/images/gallery/14/photo_004.jpg", "assets/images/gallery/14/photo_005.jpg"]
        },
        {
            cover: "assets/images/gallery/15/thumbnail.jpg",
            elements: ["assets/images/gallery/15/photo_001.jpg", "assets/images/gallery/15/photo_002.jpg", "assets/images/gallery/15/photo_003.jpg", "assets/images/gallery/15/photo_004.jpg"]
        },
        /*
        {
            cover: "assets/images/gallery/17/thumbnail.JPG",
            elements: ["assets/images/gallery/17/photo_001.JPG", "assets/images/gallery/17/photo_002.JPG", "assets/images/gallery/17/photo_003.jpg", "assets/images/gallery/17/photo_004.jpg"]
        },
        {
            cover: "assets/images/gallery/18/thumbnail.JPG",
            elements: ["assets/images/gallery/18/photo_001.JPG", "assets/images/gallery/18/photo_002.JPG", "assets/images/gallery/18/photo_003.JPG", "assets/images/gallery/18/photo_004.JPG", "assets/images/gallery/18/photo_005.JPG", "assets/images/gallery/18/photo_006.JPG"]
        },
        {
            cover: "assets/images/gallery/19/thumbnail.jpg",
            elements: ["assets/images/gallery/19/photo_001.jpg", "assets/images/gallery/19/photo_002.jpg", "assets/images/gallery/19/photo_003.jpg", "assets/images/gallery/19/photo_004.jpg", "assets/images/gallery/19/photo_005.jpg"]
        },
        {
            cover: "assets/images/gallery/2/thumbnail.jpg",
            elements: ["assets/images/gallery/2/photo_001.jpg", "assets/images/gallery/2/photo_002.jpg", "assets/images/gallery/2/photo_003.jpg", "assets/images/gallery/2/photo_004.jpg", "assets/images/gallery/2/photo_005.jpg", "assets/images/gallery/2/photo_006.jpg", "assets/images/gallery/2/photo_007.jpg", "assets/images/gallery/2/photo_008.jpg", "assets/images/gallery/2/photo_009.jpg", "assets/images/gallery/2/photo_010.jpg"]
        },
        */
        {
            cover: "assets/images/gallery/20/thumbnail.jpg",
            elements: ["assets/images/gallery/20/photo_001.jpg", "assets/images/gallery/20/photo_002.jpg", "assets/images/gallery/20/photo_003.jpg", "assets/images/gallery/20/photo_004.jpg", "assets/images/gallery/20/photo_005.jpg", "assets/images/gallery/20/photo_006.jpg", "assets/images/gallery/20/photo_007.jpg", "assets/images/gallery/20/photo_008.jpg", "assets/images/gallery/20/photo_009.jpg", "assets/images/gallery/20/photo_010.jpg", "assets/images/gallery/20/photo_011.jpg", "assets/images/gallery/20/photo_012.jpg", "assets/images/gallery/20/photo_013.jpg"]
        },
        {
            cover: "assets/images/gallery/3/thumbnail.jpg",
            elements: ["assets/images/gallery/3/photo_001.jpg", "assets/images/gallery/3/photo_002.jpg", "assets/images/gallery/3/photo_003.jpg", "assets/images/gallery/3/photo_004.jpg", "assets/images/gallery/3/photo_005.jpg", "assets/images/gallery/3/photo_006.jpg", "assets/images/gallery/3/photo_007.jpg", "assets/images/gallery/3/photo_008.jpg", "assets/images/gallery/3/photo_009.jpg", "assets/images/gallery/3/photo_010.jpg", "assets/images/gallery/3/photo_011.jpg", "assets/images/gallery/3/photo_012.jpg", "assets/images/gallery/3/photo_013.jpg"]
        },
        {
            cover: "assets/images/gallery/4/thumbnail.jpg",
            elements: ["assets/images/gallery/4/photo_001.jpg", "assets/images/gallery/4/photo_002.jpg"]
        },
        {
            cover: "assets/images/gallery/5/thumbnail.jpg",
            elements: ["assets/images/gallery/5/photo_001.jpg", "assets/images/gallery/5/photo_002.jpg"]
        },
        {
            cover: "assets/images/gallery/6/thumbnail.jpg",
            elements: ["assets/images/gallery/6/photo_001.jpg", "assets/images/gallery/6/photo_002.jpg", "assets/images/gallery/6/photo_003.jpg"]
        },
        {
            cover: "assets/images/gallery/7/thumbnail.jpg",
            elements: ["assets/images/gallery/7/photo_001.jpg", "assets/images/gallery/7/photo_002.jpg", "assets/images/gallery/7/photo_003.jpg", "assets/images/gallery/7/photo_004.jpg", "assets/images/gallery/7/photo_005.jpg", "assets/images/gallery/7/photo_006.jpg"]
        },
        {
            cover: "assets/images/gallery/8/thumbnail.jpg",
            elements: ["assets/images/gallery/8/photo_001.jpg", "assets/images/gallery/8/photo_002.jpg"]
        },
        {
            cover: "assets/images/gallery/9/thumbnail.jpg",
            elements: ["assets/images/gallery/9/photo_001.jpg", "assets/images/gallery/9/photo_002.jpg", "assets/images/gallery/9/photo_003.jpg"]
        }
    ]